<template>
  <v-chip class="font-weight-medium ag-status-chip" small :color="color" :text-color="textColor">{{ label }}</v-chip>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: String,
  },

  computed: {
    ...mapState("common", ["statuses"]),
    status() {
      return this.statuses[this.value];
    },
    label() {
      return this.status ? this.status.label : this.value;
    },
    color() {
      return this.status ? this.status.bgColor : "#eeeeee";
    },
    textColor() {
      return this.status ? this.status.textColor : "#000000";
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-status-chip.v-chip.v-size--small {
  height: 18px;
}
</style>
